/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
import { B as Button, d as defineCustomElement$1 } from './button.js';
const IonButton = Button;
const defineCustomElement = defineCustomElement$1;
export { IonButton, defineCustomElement };